import React from "react";

const applicationRoutes = [

    {
        path: "/dashboard",
        component: React.lazy(() => import("./dashboard/Dashboard")),
    },
    
    {
        path: "/welcome",
        component: React.lazy(() => import("./welcome/Welcome")),
    },


    //Inbound Enquiry
    {
        path: "/applications/inboundEnquiry/list",
        component: React.lazy(() => import("./enquiry/InboundEnquiryList")),
    },
    
    {
        path: "/applications/inboundEnquiry/:viewType/:paramId",
        component: React.lazy(() => import("./enquiry/InboundEnquiryFormDetails")),
    },

    {
        path: "/applications/inboundMessage/:viewType/:paramId",
        component: React.lazy(() => import("./enquiry/InboundEnquiryFormDetails")),
    },

    //Outbound Enquiry
    {
        path: "/applications/outboundEnquiry/list",
        component: React.lazy(() => import("./enquiry/OutboundEnquiryList")),
    },
    
    {
        path: "/applications/outboundEnquiry/:viewType/:paramId",
        component: React.lazy(() => import("./enquiry/OutboundEnquiryFormDetails")),
    },

    {
        path: "/applications/outboundMessage/:viewType/:paramId",
        component: React.lazy(() => import("./enquiry/OutboundEnquiryFormDetails")),
    },

    //Raeo App
    {
        path: "/applications/raeoApp/list",
        component: React.lazy(() => import("./raeo/RaeoList")),
    },
    
    {
        path: "/applications/raeoApp/:viewType/:paramId",
        component: React.lazy(() => import("./raeo/RaeoAppFormDetails")),
    },

    //Raeo
    
    {
        path: "/applications/raeo/:viewType/:paramId",
        component: React.lazy(() => import("./raeo/RaeoFormDetails")),
    },
    
    //Raeo Monitoring
    {
        path: "/applications/raeoMonitoring/:viewType/:paramId",
        component: React.lazy(() => import("./raeo/RaeoMonitoringFormDetails")),
    },

    {
        path: "/applications/raeoAppeal/:viewType/:paramId",
        component: React.lazy(() => import("./raeo/RaeoAppealFormDetails")),
    },

    {
        path: "/applications/raeoWithdrawal/:viewType/:paramId",
        component: React.lazy(() => import("./raeo/RaeoWithdrawalFormDetails")),
    },

    // New Route for RaeoAuditPage
    {
        path: "/applications/raeoAudit/:appId",
        component: React.lazy(() => import("./raeo/RaeoAuditPage")),
    },

    // New Route for MonitoringAuditPage
    {
        path: "/applications/monAudit/:aeoNo",
        component: React.lazy(() => import("./raeo/MonAuditPage")),
    },

    // New Route for AppealAuditPage
    {
        path: "/applications/apelAudit/:appId",
        component: React.lazy(() => import("./raeo/AppealAuditPage")),
    },

    // New Route for WithdrawalAuditPage
    {
        path: "/applications/raeoWithdrawal/:appId",
        component: React.lazy(() => import("./raeo/WithdrawalAuditPage")),
    },
];

export default applicationRoutes;

